import React, {memo} from 'react';
import {useSelector} from 'react-redux';
import {ErrorInformerRenderer} from '@/common/services/ErrorInformer';
import {selectDefaultLocationConfigShown} from '@/app/store/ui/selectors';
import {GlobalErrorMessage} from '@/common/components/GlobalErrorMessage';
import {DefaultLocationConfig} from '@/app/components/common/DefaultLocationConfig';
import {UseCookiesRequest} from '@/common/components/UseCookiesRequest';
import {GeoAccessRequest} from '@/app/components/desktop/misc/GeoAccessRequest';
import {AppBanners} from '../AppBanners';
import {AppHeader} from '../AppHeader';
import {AppRouter} from '../AppRouter';
import {AppPreFooter} from '../AppPreFooter';
import {AppFooter} from '../AppFooter';
import '@/app/styles/desktop.css';
import styles from './App.css';

export const App = memo(() => {
	const defaultLocationConfigShown = useSelector(selectDefaultLocationConfigShown);

	return (
		<ErrorInformerRenderer renderMessage={() => <GlobalErrorMessage />}>
			<div className={styles.root}>
				<AppBanners />
				<AppHeader />
				<AppRouter />
				<AppPreFooter />
				<AppFooter />
				<GeoAccessRequest />
				{defaultLocationConfigShown && <DefaultLocationConfig />}
				{/* <UseCookiesRequest />*/}
			</div>
		</ErrorInformerRenderer>
	);
});

App.displayName = 'App';
